//--- React
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Empty, Row, Table } from "antd";
//--- Project
import { UNITS } from "components/Common/Constants";
import { formatDateAndTime } from "components/Common/Utils";
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import PanelsRow from "components/Common/Grafana/PanelsRow";
import panelList from "../panelList.json";

const BatteryPerformance = ({ baseUrl, baseFilterObject, chartType }) => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [batteryList, setBatteryList] = useState([]);

  useEffect(() => {
    setBatteryList(panelList?.battery);
  }, []);

  const columns = [
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (startTime) => formatDateAndTime(startTime),
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
      render: (endTime) => formatDateAndTime(endTime),
    },
    {
      title: "Start Voltage",
      dataIndex: "startVoltage",
      key: "startVoltage",
      render: (startVoltage) => (
        <>
          {startVoltage}
          <span className="card-sub-text ml015">{UNITS.VOLTS}</span>
        </>
      ),
    },
    {
      title: "End Voltage",
      dataIndex: "endVoltage",
      key: "endVoltage",
      render: (endVoltage) => (
        <>
          {endVoltage}
          <span className="card-sub-text ml015">{UNITS.VOLTS}</span>
        </>
      ),
    },
    {
      title: "Starting Charge",
      dataIndex: "startSoc",
      key: "startSoc",
      render: (startSoc) => (
        <>
          {startSoc}
          <span className="card-sub-text ml015">{UNITS.PERCENT}</span>
        </>
      ),
    },
    {
      title: "Ending Charge",
      dataIndex: "endSoc",
      key: "endSoc",
      render: (endSoc) => (
        <>
          {endSoc}
          <span className="card-sub-text ml015">{UNITS.PERCENT}</span>
        </>
      ),
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      render: (distance) => (
        <>
          {distance}
          <span className="card-sub-text ml015">{UNITS.KM}</span>
        </>
      ),
    },
  ];

  const subContent = (
    <>
      <Row className="mt105">
        <Col span={24}>
          {tripSummary?.batteryPerformance?.length > 0 ? (
            <Table
              columns={columns}
              dataSource={tripSummary?.batteryPerformance}
              rowKey={(record) => record.startTime}
              pagination={false}
              scroll={{ x: "100%" }}
            />
          ) : (
            <Empty />
          )}
        </Col>
      </Row>
      <div className="grey-box mt105">
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="flex-center">
            Total Distance:
            <span className="ml025 bold">{tripSummary?.totalDistance}</span>
            <span className="ml025">{UNITS.KM}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="flex-center">
            Total Discharge:
            <span className="ml025 bold">{tripSummary?.totalDischarge}</span>
            <span className="ml025">{UNITS.PERCENT}</span>
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <>
      <Row className="pd0">
        {batteryList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              timeSeriesPanel={
                chartType?.timeSeries &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["timeSeries"]
              }
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default BatteryPerformance;
